<div>
  <div class="retour oneLine mt-1">
    <span>&#60;</span>
    <button (click)="retour()">{{ preferenceMessages.tab_2_retour | translate }}</button>
  </div>
  <div class="mt-3">
    <div class="oneLine" *ngIf="action === 'ajouter'">
      <h2>{{ preferenceMessages.tab_2_label_4 | translate }}</h2>
      <app-partage-preference (preferenceCopied)="partageReturn($event)"></app-partage-preference>
    </div>
    <h2 *ngIf="action === 'modifier'">{{ preferenceMessages.tab_2_label_4_bis | translate }}</h2>
  </div>
  <div class="content">
    <div class="research-part">
      <div class="search" role="search">
        <label class="required">{{ preferenceMessages.tab_2_label_8 | translate }}</label>
        <div class="field">
          <input id="input-search" type="search" (keyup.enter)="search(searchValue)" [(ngModel)]="searchValue">
          <button id="button-search" (click)="search(searchValue)">
            <mat-icon>search</mat-icon>
          </button>
        </div>
      </div>
      <div class="mt-3 mb-3">
        <span>({{cpvCount()}} {{ preferenceMessages.tab_2_resultat | translate }})</span>
      </div>
      <div class="cpv_result">
        <div *ngFor="let item of cpvList; let i = index;">
          <div *ngIf="cpvList?.length <= limitMaxCpv">
            <input class="mr-1 cpv_result_input" type="checkbox" [id]="'checkbox-'+i" name="checkbox" [(ngModel)]="item.status"
              (change)="changeCheckbox(item)">
            <span>{{item.code}} - {{item.libelle | translate }}</span>
          </div>
        </div>
        <span *ngIf="cpvList?.length > limitMaxCpv" class="text-danger">{{ preferenceMessages.tab_2_resultat_error |
          translate }}</span>
        <button [disabled]="cpvListTmp?.length===0" (click)="addCpv()" class="btn btn-primary mt-2 mb-3">
          {{ preferenceMessages.tab_2_label_9 | translate }}
        </button>
      </div>
    </div>
    <div class="display-part">
      <h3 *ngIf="action === 'ajouter'">{{ preferenceMessages.tab_2_label_5 | translate }}</h3>
      <h3 *ngIf="action === 'modifier'">{{ preferenceMessages.tab_2_label_5_bis | translate }}</h3>
      <div class="oneLine">
        <p>{{ preferenceMessages.tab_2_label_6_part1 | translate }}</p>
        <p class="red">&nbsp;*&nbsp;</p>
        <p>{{ preferenceMessages.tab_2_label_6_part2 | translate }}</p>
      </div>
      <form class="form" [formGroup]="form">
        <div id="intitule">
          <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_2_label_intitule | translate"
            [type]="'text'" [rule]="'required'" [name]="'preference_SepAtt_cpv_SepAtt_intitule'">
          </app-form-input>
        </div>
        <div class="oneLine">
          <h4>{{ preferenceMessages.tab_2_label_7 | translate }} ({{selectCount()}})</h4>
          <button type="button" (click)="reset()" class="ml-3 btn btn-outline-primary" id="reset">
            <span>
              {{ preferenceMessages.tab_2_reset | translate }}
            </span>
            <mat-icon>replay</mat-icon>
          </button>
        </div>
        <div id="etiquette-group" class="mt-3">
          <div *ngFor="let item of preference?.content?.values" class="etiquette">
            <span class="text-etiquette">{{item.code}} - {{item.value | translate }}</span>
            <div class="icon-etiquette">
              <mat-icon class="delete-icon" (click)="delete(item)">highlight_off</mat-icon>
            </div>
          </div>
        </div>
        <button *ngIf="action === 'ajouter'" [disabled]="(!form.valid)||preference?.content?.values.length>3"
          (click)="savePref()" class="btn btn-primary">
          {{ preferenceMessages.tab_4_label_ajouter | translate }}
        </button>
        <button *ngIf="action === 'modifier'" [disabled]="(!form.valid)||preference?.content?.values.length>3"
          (click)="savePref()" class="btn btn-primary">
          {{ preferenceMessages.tab_4_label_modifier | translate }}
        </button>
        <button id="annuler" (click)="annuler()" class="btn btn-outline-primary ml-2">
          {{ preferenceMessages.tab_4_label_annuler | translate }}
        </button>
        <span *ngIf="preference?.content?.values.length>3" class="text-danger ml-3">{{ preferenceMessages.tab_2_max_liste_error |
          translate }}</span>
      </form>
    </div>
  </div>
</div>
